document.querySelectorAll(".toggle-popup").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    var target = obj.getAttribute("data-target");
    var target_popup = document.getElementById(target);
    target_popup.classList.add("opened");
    if(target_popup.querySelector(".content-slider") && !target_popup.querySelector(".content-slider").classList.contains("flickity-enabled")) {
      var flkty = new window.ThemeFlickity( target_popup.querySelector(".content-slider"), {
        "pageDots": false
      });
    }
  });
});

document.querySelectorAll(".popup .btn-close").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    var popup = obj.closest(".popup");
    popup.classList.remove("opened");
  });
});

document.querySelectorAll(".popup").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    if(e.target.closest(".popup-inner") == null) {
      obj.classList.remove("opened");
    }
  });
});

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

function updatePrice() {
  var tot_price = parseInt(document.querySelector(".product-form__variants .block-swatch__radio:checked+.block-swatch__item .sale_price").getAttribute("data-price"));
  var tot_regprice = parseInt(document.querySelector(".product-form__variants .block-swatch__radio:checked+.block-swatch__item .reg_price").getAttribute("data-price"));

  document.querySelectorAll(".addon-btn.added").forEach(function(obj1) {
    tot_price += parseInt(obj1.getAttribute("data-price"));
    tot_regprice += parseInt(obj1.getAttribute("data-regprice"));
  });

  document.querySelector(".price-list .price--compare .money").textContent = formatMoney(tot_regprice);
  document.querySelector(".price-list .price--highlight .money").textContent = formatMoney(tot_price);  
  document.querySelector(".product-sticky-form__price").textContent = formatMoney(tot_price);
  document.querySelector(".product-sticky-form .price--compare .money").textContent = formatMoney(tot_regprice);
}

document.querySelectorAll(".addon-btn").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    var id = this.getAttribute("data-id");
    var addon_list = document.querySelector("[name='addon']");

    this.classList.toggle("added");
    
    var added_ids = [];    
    document.querySelectorAll(".addon-btn.added").forEach(function(obj1) {
      added_ids.push(obj1.getAttribute("data-id"));
    });
    
    addon_list.value = added_ids;

    updatePrice();
  });
});

document.addEventListener("variantChanged", function(e) {
  updatePrice();
  var variant_id = e.detail.id;
  document.querySelectorAll(".addon-item").forEach(function(obj) {
    if(obj.querySelector(".addon-btn").classList.contains("added")) {
      obj.querySelector(".addon-btn").click();
    }
    var id = obj.getAttribute("data-for");
    if(id == variant_id) {
      obj.classList.remove("hide");
    }
    else {
      obj.classList.add("hide");
    }
  });
});

document.querySelectorAll(".trigger-affirm").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    if(document.querySelector(".affirm-modal-trigger")) {
      document.querySelector(".affirm-modal-trigger").click();
    }
  });
});